import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'

import { AD_SERVER_TYPE, API_KEY } from './reusableFields'

import useCommonStyles from '../../../../styles/common/listPage'

function AdServerFormSkeleton() {
  const { t } = useTranslation()

  const commonClasses = useCommonStyles()

  return (
    <div className={commonClasses.formRow}>
      <FieldLabelWrapper label={t('Ad Server Name')} labelFor={AD_SERVER_TYPE}>
        <Skeleton style={{ height: 30, marginTop: 5 }} />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('API key')} labelFor={API_KEY}>
        <Skeleton style={{ height: 30, marginTop: 5 }} />
      </FieldLabelWrapper>
    </div>
  )
}

export default AdServerFormSkeleton
